<template>
  <div id="app" v-loading="loading">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      loading: false
    }
  }
}
</script>

<style lang="scss">
// 以下2つのCSSは編集しないで下さい！！！！
@import "./assets/common/html5doctor";
@import "../node_modules/element-ui/lib/theme-chalk/index.css";
@import "./assets/css/App";
</style>



// WEBPACK FOOTER //
// src/App.vue